import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Star, Zap, Crown } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import MainNavigation from '../components/layout/MainNavigation';
import Footer from '../components/layout/Footer';

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <MainNavigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pricing details coming soon. Contact us for custom enterprise solutions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Placeholder pricing cards */}
          <Card className="border-2 hover:border-blue-500 transition-all">
            <CardContent className="p-8 text-center">
              <Star className="w-12 h-12 text-blue-600 mx-auto mb-4" />
              <h3 className="text-2xl font-bold mb-2">Free</h3>
              <p className="text-gray-600 mb-6">Get started today</p>
              <Button className="w-full bg-blue-600 hover:bg-blue-700">
                Start Free
              </Button>
            </CardContent>
          </Card>

          <Card className="border-2 border-purple-500 shadow-xl transform scale-105">
            <CardContent className="p-8 text-center">
              <Zap className="w-12 h-12 text-purple-600 mx-auto mb-4" />
              <h3 className="text-2xl font-bold mb-2">Pro</h3>
              <p className="text-gray-600 mb-6">For professionals</p>
              <Button className="w-full bg-purple-600 hover:bg-purple-700">
                Coming Soon
              </Button>
            </CardContent>
          </Card>

          <Card className="border-2 hover:border-indigo-500 transition-all">
            <CardContent className="p-8 text-center">
              <Crown className="w-12 h-12 text-indigo-600 mx-auto mb-4" />
              <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
              <p className="text-gray-600 mb-6">Custom solutions</p>
              <Button className="w-full bg-indigo-600 hover:bg-indigo-700">
                Contact Sales
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Pricing;
